import { LibraryRegular, LibraryFilled, LinkMultipleFilled, LinkMultipleRegular } from '@fluentui/react-icons';
import { createCompositeIcon } from './createCompositeIcon';

/**
 * Library-link = library icon with a link badge.
 * We expose separate `Regular` / `Filled` variants (Fluent-UI style).
 */
export const { regular: LibraryLinkRegular, filled: LibraryLinkFilled } = createCompositeIcon(
  // background / base layer
  {
    regular: LibraryRegular,
    filled: LibraryFilled,
    props: {
      scale: 0.9,
      offsetX: 3,
      offsetY: -1,
    },
  },

  // foreground / overlay layer
  // NOTE: regular/filled are intentionally swapped for contrast -
  // a filled badge on an outlined base, and vice versa.
  {
    regular: LinkMultipleFilled,
    filled: LinkMultipleRegular,
    props: {
      scale: 0.6,
      offsetX: -0.6,
      offsetY: 13.5,
    },
  }
);
